import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import React__default from 'react';
import { BaseIconButton } from '../LegacyIconButton/BaseIconButton.es.js';

const colorMappings = {
  "icon-primary": "icon-primary-dark",
  "icon-secondary": "icon-secondary-dark"
};
function DarkBackgroundIconButton(_a) {
  var { color = "icon-primary" } = _a, props = __rest(_a, ["color"]);
  return React__default.createElement(BaseIconButton, Object.assign({ color: colorMappings[color], size: "small" }, props));
}

export { DarkBackgroundIconButton };
//# sourceMappingURL=DarkBackgroundIconButton.es.js.map
